import { UserRolesEnum } from "../typings";

export const ADMIN_PERMISSIONS = [UserRolesEnum.ADMIN];
export const SUPER_ADMIN_PERMISSIONS = [UserRolesEnum.SUPER_ADMIN];
export const INTERVIEWER_PERMISSIONS = [
  UserRolesEnum.INTERVIEWER,
  ...ADMIN_PERMISSIONS,
  ...SUPER_ADMIN_PERMISSIONS,
];
export const MENTOR_PERMISSIONS = [
  UserRolesEnum.MENTOR,
  ...ADMIN_PERMISSIONS,
  ...SUPER_ADMIN_PERMISSIONS,
];
export const DONOR_PERMISSIONS = [
  UserRolesEnum.DONOR,
  ...ADMIN_PERMISSIONS,
  ...SUPER_ADMIN_PERMISSIONS,
];
export const ACCOUNTANT_PERMISSIONS = [
  UserRolesEnum.ACCOUNTANT,
  ...ADMIN_PERMISSIONS,
  ...SUPER_ADMIN_PERMISSIONS,
];
export const STUDENT_PERMISSIONS = [
  UserRolesEnum.STUDENT,
  ...ADMIN_PERMISSIONS,
  ...SUPER_ADMIN_PERMISSIONS,
];
export const STUDENT_ONLY_PERMISSIONS = [
  UserRolesEnum.STUDENT,
];
export const ALL_PERMISSIONS = [
  UserRolesEnum.STUDENT,
  UserRolesEnum.ADMIN,
  UserRolesEnum.SUPER_ADMIN,
  UserRolesEnum.ACCOUNTANT,
  UserRolesEnum.DONOR,
  UserRolesEnum.INTERVIEWER,
  UserRolesEnum.MENTOR,
];
